module.exports = __webpack_public_path__ + "static/media/Sent.8e50a288.svg";